import { useEffect, useState } from "react";
import { ContractService } from "../../../../../../core/services/ContractService";
import { Singleton } from "../../../../../../core/services/Singleton";
import { Modal } from "../../../../../theme/Component/Modal";
import { ManageAdquisitionItem } from "./ManageAdquisitionItem";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ObjectDinamicViewer } from "../FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import { toast } from "react-toastify";

interface Config {
    filterState?: number;
    label?: string;
    notSeeProps?: boolean
    disable?: boolean
}

interface Props {
    idAdquisitionItem?: number;
    onChage: Function;
    ConfigProps?: Config;
    listStates?: any;
}
export const AdquisitionItemSelector = ({ idAdquisitionItem, onChage, ConfigProps, listStates }: Props) => {

    const single = Singleton.getInstance();
    const service = new ContractService();

    const [item, setItem] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    const [modal, setModal] = useState<any>({ name: "Necesidades por Plan de Compras", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalSee, setModalSee] = useState<any>({ name: "Necesidad", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (idAdquisitionItem) {
            getItem(idAdquisitionItem);
        } else {
            setItem({})
        }
    }, [idAdquisitionItem])

    const getItem = (idItem) => {
        single.spinner(true);
        service.getAdquisitionItem(idItem).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let itemResp = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    if (itemResp.IDAdquisitionItem && itemResp.IDAdquisitionItem != item.IDAdquisitionItem) {
                        onChage(itemResp);
                        setItem(itemResp);
                    }
                }
                single.spinner(false);
            }
        )
    }

    const selecionarItem = () => {
        if (bean.IDAdquisitionItem) {
            setItem(bean)
            onChage(bean)
            setModal({ ...modal, "view": false });
        } else {
            toast.error("Objeto no valido")
        }
    }

    return (
        <>
            <div className="row">
                {/* <PrintJson json={item} /> */}
                <div className="col-md-12">
                    <label>{item.IDAdquisitionItem ? "ID de la Necesidad" : ConfigProps?.label ?? "Buscar Necesidad"}</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder='Buscar...'
                            value={item.IDAdquisitionItem || ""}
                            onClick={() => {
                                if (!ConfigProps?.disable) {
                                    setModal({ ...modal, view: true });
                                }
                            }}
                            disabled={ConfigProps?.disable}
                        />
                    </div>
                </div>
                {(item.IDAdquisitionItem && !ConfigProps?.notSeeProps) &&
                    <>
                        {/* <PrintJson json={item} /> */}
                        {/* <div className="col-lg-6">
                            <label>Valor de Artículos</label>
                            <input className="form-control" disabled value={item.TotalArticle} />
                        </div> */}
                        <div className="col-lg-6">
                            <label>Oficina</label>
                            <input className="form-control" disabled value={item.IDLnFunctionalIDName} />
                        </div>
                        {item.IDProject &&
                            <div className="col-lg-6">
                                <label>Proyecto</label>
                                <input className="form-control" disabled value={item.ProjectName ?? item.IDProject} />
                            </div>
                        }
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea rows={5} className="form-control" value={item.Description} disabled />
                        </div>
                    </>
                }
            </div>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={selecionarItem} onSubmitLabel="Seleccionar Necesidad" >
                    <ManageAdquisitionItem _onChange={(e) => { setBean(e) }}
                        // filterState={ConfigProps?.filterState} 
                        listfilterState={listStates ? listStates : []}
                    />
                </Modal>
            }
        </>
    )
}